export default __webpack_public_path__ + "static/media/trash-bin.82070881.svg";